import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Title = styled.h3`
  font-size: 32px;
  font-weight: 700;
  color: ${colors.green};
  padding: 8px 0px;
`
export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.gray7};
  padding: 8px 0px;
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-height: 350px;
  margin: 32px;
  padding: 32px;
  background-color: ${colors.white};

  @media (max-width: 669px) {
    max-height: 550px;
  }
`
